import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { Badge, Row } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { Button, CellFormatOptions, Icon } from '@octano/global-ui';
import { ClassroomApiResponse } from '../types';

type UseColumnsProps = {
  onEdit: (classroom: ClassroomApiResponse) => void;
  onDelete: (classroom: ClassroomApiResponse) => void;
  onDisable: (classroom: ClassroomApiResponse) => void;
};

export const useColumns = ({
  onEdit,
  onDelete,
  onDisable,
}: UseColumnsProps) => {
  const { t } = useTranslation(TranslationsKeys.MANAGEMENT_TOOLS_CLASSROOMS);
  const history = useHistory();

  return [
    {
      columnName: 'name',
      headerText: t('table.headers.name'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'code',
      headerText: t('table.headers.code'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'type',
      headerText: t('table.headers.type'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'campus',
      headerText: t('table.headers.campus'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'capacity',
      headerText: t('table.headers.capacity'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'state',
      headerText: t('table.headers.state'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ row }: CellFormatOptions<ClassroomApiResponse>) => {
        return (
          <Badge
            className="fs-14 fw-400 py-2 px-3 text-dark w-auto"
            style={{
              backgroundColor: row?.isEnabled ? '#CEF0DA' : '#FFE6A1',
            }}
            pill
          >
            {row?.isEnabled ? 'Habilitado' : 'Deshabilitado'}
          </Badge>
        );
      },
    },
    {
      columnName: 'action',
      headerText: t('table.headers.action'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ row }: CellFormatOptions<ClassroomApiResponse>) => {
        return (
          <Row className="d-flex justify-content-center">
            <button className="btn" onClick={() => onEdit(row)}>
              <Icon name="edit" color={'primary'} />
            </button>
            <button className="btn" onClick={() => onDelete(row)}>
              <Icon name="trash" color={'primary'} />
            </button>
          </Row>
        );
      },
    },
    {
      columnName: 'manage',
      headerText: t('table.headers.manage'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ row }: CellFormatOptions<ClassroomApiResponse>) => {
        return (
          <div className="d-flex flex-row justify-content-center">
            {row.isEnabled && (
              <Button
                text={t('table.buttons.disable')}
                size="sm"
                color="primary"
                onClick={() => onDisable(row)}
                className="mr-2"
                outlined
              />
            )}
            <Button
              text={t('table.buttons.calendar')}
              size="sm"
              color="primary"
              onClick={() => history.push(`/classrooms/${row.id}/calendar`)}
            />
          </div>
        );
      },
    },
  ];
};
